<template>
  <div class="border-t border-backdrop-50"></div>
</template>

<script>
export default {
  name: 'Divider'
}
</script>

<style scoped>

</style>
